import React, { useState } from 'react';
import clsx from 'clsx';
import EnterpriseLayout from "../components/layout/EnterpriseLayout";
import WhitelistTable from '../components/WhitelistTable';
import AddWhitelistWalletModal from '../components/modals/AddWhitelistWalletModal';
import styles from '../styles/views/Whitelist.module.scss';

function Whitelist() {
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleRefresh = () => {
    // Trigger a refresh of the whitelist table
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <EnterpriseLayout
      pageTitle="Whitelist"
      pageDescription="Manage authorized wallet addresses that can draw credit. Only whitelisted addresses that have been reviewed and approved will be allowed to participate in the credit system."
      pageBodyClassName={clsx(styles.cWhitelist, "c-whitelist")}
    >
      <div className={styles.whitelistContainer}>
        {/* Main Content */}
        <div className={styles.mainContent}>
          <div className={styles.contentHeader}>
            <h2 className={styles.sectionTitle}>Whitelisted Addresses</h2>
            <div className={styles.contentActions}>
              <AddWhitelistWalletModal onRefresh={handleRefresh} />
            </div>
          </div>
          
          <div className={styles.tableSection}>
            <WhitelistTable refreshTrigger={refreshTrigger} />
          </div>
        </div>
      </div>
    </EnterpriseLayout>
  );
}

export default Whitelist;